import type { z } from "zod";

import { ImpulseFormList, ImpulseFormShape, ImpulseFormUnit } from "~/tools/impulse-form";
import { isStringDirty } from "~/tools/is-string-dirty";
import { prop } from "~/tools/prop";
import type { Template } from "~/tools/template";

import { type DashboardMetricsMatchers, dashboardMetricsMatchers } from "../../../../common/dashboard-spec";
import type { FormProcessor } from "../../_form-processor";

const matcherSchema = dashboardMetricsMatchers.removeCatch().sourceType().element.removeCatch().unwrap();

export type SeriesSelectorState = ImpulseFormShape<{
	id: string;
	selector: ImpulseFormUnit<string, ReadonlyArray<string>, Template<["${", "}"], null>>;
}>;

export function initSeriesSelectorState(id: string, matcher?: z.infer<typeof matcherSchema>): SeriesSelectorState {
	return ImpulseFormShape({
		id,
		selector: ImpulseFormUnit(matcher?.source ?? "", {
			isInputDirty: isStringDirty,
			schema: matcherSchema,
		}),
	});
}

export type FormState = ImpulseFormList<SeriesSelectorState>;

export const Processor: FormProcessor<FormState, undefined | DashboardMetricsMatchers> = {
	fromSpec: (matchers = []) =>
		ImpulseFormList(matchers.map((matcher, index) => initSeriesSelectorState(index.toString(), matcher))),

	toSpec: (matchers) => matchers.map(prop("selector")),
};
